import styled from 'styled-components';
import { ReactComponent as SkullSvg } from '../../../../images/skull.svg';

const LayoutWrapperStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  height: 100vh;
  padding: 32px;

  :before {
    content: '';
    position: absolute;
    top: 0;
    width: 100%;
    height: 6px;
    background: linear-gradient(270deg, #ed1e79 0%, #451287 100%);
  }
`;

const ContentStyled = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 328px;
`;

const SkullSvgStyled = styled(SkullSvg)`
  flex-shrink: 0;
  margin-bottom: 23px;
`;

const TitleStyled = styled.h1`
  font-size: 20px;
  line-height: 26px;
  font-weight: 700;
  color: #0e141d;
  margin-bottom: 16px;
`;

const MessageStyled = styled.p`
  font-size: 16px;
  line-height: 20px;
  font-weight: 300;
  color: #494c66;
  text-align: center;
  margin-bottom: 32px;

  strong {
    font-weight: 700;
  }
`;

const UnderlineButtonStyled = styled.button`
  background: none;
  border: none;
  color: #e92070;
  font-size: 14px;
  line-height: 20px;
  text-decoration: underline;
  cursor: pointer;
  margin-top: 8px;
`;

export {
  LayoutWrapperStyled,
  ContentStyled,
  SkullSvgStyled,
  TitleStyled,
  MessageStyled,
  UnderlineButtonStyled,
};
